import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreAgentConversationsSlice } from './get';

import { coreRecentAgentConversationsReducers, coreRecentAgentConversationsWatchers } from './recent';

export const coreAgentConversationsReducers = combineReducers({
	get: getCoreAgentConversationsSlice.asyncReducers,
	recent: coreRecentAgentConversationsReducers
});

export const coreAgentConversationsWatchers = combineAllWatchers([
	getCoreAgentConversationsSlice.asyncWatchers,
	coreRecentAgentConversationsWatchers
]);
